// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"65e6028d","772":"9c2f99e9","778":"20661125","921":"bbaa7d82"}[chunkId] + ".chunk.css";
};